import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { getSingleRole } from "api/graphQL_role";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { getId } from "utils/auth";
import BlackList from "./components/BlackList";
import CreateBlockClientsModal from "./components/CreateBlockeclientModal";
import { getAllWhiteList } from "api/whiteListed";

export type BlackListClientsRowObj = {
  id: string;
  created_at: string;
  first_name: string;
  last_name: string;
  email?: string;
  is_blacklisted?: boolean;
  bin: string;
  last_four: string;
  attempts?: string;
};

const WhiteListClients = (props: {
  gatewayTypes?: any;
  type?: any;
  client_id?: any;
}) => {
  const { gatewayTypes, type, client_id } = props;
  let gateway = gatewayTypes.filter((data: any) => data?.name === type);
  let gateway_id = gateway && gateway.length > 0 ? gateway[0]?.id : "";

  const [blackListClients, setBlackListClients] = useState<BlackListClientsRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const { singleRoleData, setSingleRoleData, filter } = useContext(ClientContext);

  const fetchBlackListClientsData = () => {
    setIsLoading(true);
    getAllWhiteList(client_id, gateway_id)
      .then((data) => setBlackListClients(data))
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching data!"))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (gateway_id && client_id) fetchBlackListClientsData();
  }, [page, pageSize, filter, searchTexts, type]);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
      setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  return (
    <div className="wl-root">
      <div className="wl-toolbar">
        <div className="wl-toolbar-left">
          <div className="wl-section-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
            </svg>
          </div>
          <div>
            <h3 className="wl-section-title">Whitelist Records</h3>
            <p className="wl-section-sub">Manage allowed clients for this gateway</p>
          </div>
        </div>
        {singleRoleData?.[0]?.whitelist?.value?.add_whitelist && (
          <CreateBlockClientsModal
            fetchBlackListClientsData={fetchBlackListClientsData}
            roleData={singleRoleData}
            gateway_id={gateway_id}
            client_id={client_id}
          />
        )}
      </div>

      {singleRoleData?.[0]?.whitelist?.value?.view_whitelist && (
        <BlackList
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalpage={totalpage}
          totalItems={totalItems}
          currentPage={currentPage}
          roleData={singleRoleData}
          tableData={blackListClients}
          fetchBlackListClientsData={fetchBlackListClientsData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onValueChange={serchboxValueChange}
        />
      )}

      <WlStyles />
    </div>
  );
};

const WlStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

    .wl-root { font-family: 'Plus Jakarta Sans', sans-serif; display: flex; flex-direction: column; gap: 16px; }

    .wl-toolbar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 20px 24px; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; box-shadow: 0 1px 4px rgba(15,23,42,.05); }
    .wl-toolbar-left { display: flex; align-items: center; gap: 12px; }
    .wl-section-icon { width: 38px; height: 38px; border-radius: 10px; background: linear-gradient(135deg,#f0fdf4,#dcfce7); border: 1.5px solid #bbf7d0; display: flex; align-items: center; justify-content: center; color: #16a34a; flex-shrink: 0; }
    .wl-section-title { font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 2px;line-height:22px }
    .wl-section-sub { font-size: 12px; color: #94a3b8; font-weight: 500; }
  `}</style>
);

export default WhiteListClients;